import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { toNumber } from 'lodash';
import { useGetFundQuery, useGetFundReportQuery, useListUserInputsQuery, useUpdateAccountMutation } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'TopInvestments',
  setup: function setup(__props) {
    var route = useRoute();
    var _useGetFundReportQuer = useGetFundReportQuery(computed(function () {
        return {
          input: {
            id: toNumber(route.params.fund),
            referencePeriodId: toNumber(route.query.referencePeriodId)
          }
        };
      }), computed(function () {
        var _route$query;
        return {
          enabled: !!((_route$query = route.query) !== null && _route$query !== void 0 && _route$query.referencePeriodId) && !!route.params.fund
        };
      })),
      calculatedSfdrReportResult = _useGetFundReportQuer.result;
    var _useGetFundQuery = useGetFundQuery(computed(function () {
        return {
          id: toNumber(route.params.fund)
        };
      })),
      getFundResult = _useGetFundQuery.result;
    var fund = computed(function () {
      var _getFundResult$value;
      return (_getFundResult$value = getFundResult.value) === null || _getFundResult$value === void 0 ? void 0 : _getFundResult$value.getFund;
    });
    var createUserInputs = function createUserInputs(questionId) {
      return computed(function () {
        var _fund$value$ventureId, _fund$value, _fund$value$ventureId2;
        return (_fund$value$ventureId = (_fund$value = fund.value) === null || _fund$value === void 0 ? void 0 : (_fund$value$ventureId2 = _fund$value.ventureIds) === null || _fund$value$ventureId2 === void 0 ? void 0 : _fund$value$ventureId2.map(function (id) {
          return {
            questionId: questionId,
            ventureId: id,
            periodId: null
          };
        })) !== null && _fund$value$ventureId !== void 0 ? _fund$value$ventureId : [];
      });
    };
    var industryUserInputs = createUserInputs(991199); // Primary Industry question id from company info
    var countryUserInputs = createUserInputs(2602); // Country question id from company info

    var _useListUserInputsQue = useListUserInputsQuery(computed(function () {
        return {
          input: countryUserInputs.value
        };
      }), computed(function () {
        return {
          enabled: countryUserInputs.value.length > 0
        };
      })),
      countryResults = _useListUserInputsQue.result;
    var _useListUserInputsQue2 = useListUserInputsQuery(computed(function () {
        return {
          input: industryUserInputs.value
        };
      }), computed(function () {
        return {
          enabled: industryUserInputs.value.length > 0
        };
      })),
      industryResults = _useListUserInputsQue2.result;
    var createUserInputMapping = function createUserInputMapping(results) {
      return computed(function () {
        var _results$value$listUs, _results$value;
        return Object.fromEntries(((_results$value$listUs = (_results$value = results.value) === null || _results$value === void 0 ? void 0 : _results$value.listUserInputs) !== null && _results$value$listUs !== void 0 ? _results$value$listUs : []).filter(function (input) {
          return input.userInput != null;
        }).map(function (input) {
          return [input.ventureId, input.userInput];
        }));
      });
    };
    var countryMapping = createUserInputMapping(countryResults);
    var industryMapping = createUserInputMapping(industryResults);
    var lookUpUserInput = function lookUpUserInput(mapping) {
      return function (ventureId) {
        return mapping.value[ventureId];
      };
    };
    var lookUpCountryUserInput = lookUpUserInput(countryMapping);
    var lookUpIndustryUserInput = lookUpUserInput(industryMapping);
    var calculatedSfdrReport = computed(function () {
      var _calculatedSfdrReport;
      return ((_calculatedSfdrReport = calculatedSfdrReportResult.value) === null || _calculatedSfdrReport === void 0 ? void 0 : _calculatedSfdrReport.getFundReport) || {
        nameOfFinancialMarketParticipant: '',
        legalEntityIdentifier: ''
      };
    });
    var _useNuxtApp = useNuxtApp(),
      $i18n = _useNuxtApp.$i18n;
    var locale = computed(function () {
      return $i18n.locale;
    });
    var headerMapping = computed(function () {
      return {
        investment: {
          en: 'Largest investments',
          de: 'Größte Investitionen'
        },
        industry: {
          en: 'Industry',
          de: 'Branche'
        },
        percentAssets: {
          en: '% Assets',
          de: '% Vermögenswerte'
        },
        country: {
          en: 'Country',
          de: 'Land'
        }
      };
    });
    var investments = ref({
      selected: [],
      headers: [{
        text: headerMapping.value.investment[locale.value],
        value: 'investment',
        sortable: true,
        align: 'center',
        width: '100px'
      }, {
        text: headerMapping.value.industry[locale.value],
        value: 'sector',
        sortable: true,
        align: 'center',
        width: '50%',
        cellClass: 'absolute'
      }, {
        text: headerMapping.value.percentAssets[locale.value],
        value: 'percentAssets',
        sortable: true,
        align: 'center',
        width: '100px'
      }, {
        text: headerMapping.value.country[locale.value],
        value: 'country',
        sortable: true,
        align: 'center',
        width: '50%',
        cellClass: 'absolute'
      }]
    });
    var _useUpdateAccountMuta = useUpdateAccountMutation(),
      updateAccount = _useUpdateAccountMuta.mutate;
    var triggerUpdateCountriesNace = function triggerUpdateCountriesNace(key, val, item) {
      var input = {
        id: item.id
      };
      input[key] = val === undefined || val === '' ? null : val;
      updateAccount({
        input: input
      });
    };
    return {
      __sfc: true,
      route: route,
      calculatedSfdrReportResult: calculatedSfdrReportResult,
      getFundResult: getFundResult,
      fund: fund,
      createUserInputs: createUserInputs,
      industryUserInputs: industryUserInputs,
      countryUserInputs: countryUserInputs,
      countryResults: countryResults,
      industryResults: industryResults,
      createUserInputMapping: createUserInputMapping,
      countryMapping: countryMapping,
      industryMapping: industryMapping,
      lookUpUserInput: lookUpUserInput,
      lookUpCountryUserInput: lookUpCountryUserInput,
      lookUpIndustryUserInput: lookUpIndustryUserInput,
      calculatedSfdrReport: calculatedSfdrReport,
      $i18n: $i18n,
      locale: locale,
      headerMapping: headerMapping,
      investments: investments,
      updateAccount: updateAccount,
      triggerUpdateCountriesNace: triggerUpdateCountriesNace
    };
  }
});